module.exports = __webpack_public_path__ + "img/login-jardindelvalle.6e63f683.svg";